export const DELIVERY_DEPARTMENTS = ["Sonsonate"];

export const SONSONATE_MUNICIPALITIES = [
  "Acajutla",
  "Armenia",
  "Caluco",
  "Cuisnahuat",
  "Izalco",
  "Juayua",
  "Nahuizalco",
  "Nahulingo",
  "Salcoatitan",
  "San Antonio del Monte",
  "San Julian",
  "Santa Catarina Masahuat",
  "Santa Isabel Ishuatan",
  "Santo Domingo de Guzman",
  "Sonsonate",
  "Sonzacate"
];

export const DEFAULT_DELIVERY_RATES = {
  Acajutla: 4,
  Armenia: 4,
  Caluco: 3,
  Cuisnahuat: 5,
  Izalco: 3,
  Juayua: 5,
  Nahuizalco: 3.5,
  Nahulingo: 2.5,
  Salcoatitan: 5,
  "San Antonio del Monte": 2.5,
  "San Julian": 4,
  "Santa Catarina Masahuat": 5,
  "Santa Isabel Ishuatan": 6,
  "Santo Domingo de Guzman": 6,
  Sonsonate: 2,
  Sonzacate: 2
};
